import React from "react";
import { RouteNode } from "react-router5";
import { inject, observer } from "mobx-react";
import { ROUTE_PROCESSED_QUALITIES } from "../../routes";
import Qualities from "./Qualities";
@inject((stores) => ({
  router: stores.router,
}))
@observer
class ProcessedQualities extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Qualities type="processed" />;
  }
}

export default (props) => (
  <RouteNode nodeName={ROUTE_PROCESSED_QUALITIES}>
    {(routeProps) => <ProcessedQualities {...routeProps} {...props} />}
  </RouteNode>
);
